<nz-layout class="app-layout" *ngIf="user else login">
    <nz-sider class="menu-sidebar"
      nzTheme="light"
      nzCollapsible
      nzMode="inline"
      nzWidth="256px"
      nzBreakpoint="md"
      [(nzCollapsed)]="isCollapsed"
      [nzTrigger]="null">
      <div class="sidebar-logo" routerLink="/">
         <img src="assets/logo.svg" alt="logo">
          <h1>YOMA Admintool</h1>
      </div>
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
        <li nz-menu-item routerLink="/alert-status" nzMatchRouter>
          <span nz-icon nzType="warning" nzTheme="outline"></span>
          <span>Alert Status</span>
        </li>
        <li nz-submenu nzTitle="Dashboard" nzIcon="dashboard" [nzOpen]="isGroupActive(['/statistics', '/decision-maker', '/api-calls'])">
          <ul>
            <li nz-menu-item routerLink="/statistics" nzMatchRouter>
              <span nz-icon nzType="dashboard" nzTheme="outline"></span>
              <span>Frontend</span>
            </li>
            <li nz-menu-item routerLink="/decision-maker" nzMatchRouter>
              <span nz-icon nzType="fund-projection-screen" nzTheme="outline"></span>
              <span>Decision Maker</span>
            </li>
            <li nz-menu-item routerLink="/api-calls" nzMatchRouter>
              <span nz-icon nzType="api" nzTheme="outline"></span>
              <span>API</span>
            </li>
          </ul>
        </li>
        <li nz-submenu nzTitle="Tenants & Features" nzIcon="team" [nzOpen]="isGroupActive(['/tenants', '/users', '/features'])">
          <ul>
            <li nz-menu-item routerLink="/tenants" nzMatchRouter>
              <span nz-icon nzType="team" nzTheme="outline"></span>
              <span>Tenants</span>
            </li>
            <li nz-menu-item routerLink="/users" nzMatchRouter>
              <span nz-icon nzType="user" nzTheme="outline"></span>
              <span>Users</span>
            </li>
            <li nz-menu-item routerLink="/features" nzMatchRouter>
              <span nz-icon nzType="merge-cells" nzTheme="outline"></span>
              <span>Features</span>
            </li>
          </ul>
        </li>
        <li nz-submenu nzTitle="Settings" nzIcon="setting" [nzOpen]="isGroupActive(['/standard-tile', '/quickfilter', '/standardfilter', '/config', '/data-sources'])">
          <ul>
            <li nz-menu-item routerLink="/standard-tile" nzMatchRouter>
              <span nz-icon nzType="appstore" nzTheme="outline"></span>
              <span>Default Find Tile</span>
            </li>
            <li nz-menu-item routerLink="/quickfilter" nzMatchRouter>
              <span nz-icon nzType="filter" nzTheme="outline"></span>
              <span>Quickfilter</span>
            </li>
            <li nz-menu-item routerLink="/standardfilter" nzMatchRouter>
              <span nz-icon nzType="filter" nzTheme="outline"></span>
              <span>Standardfilter</span>
            </li>
            <li nz-menu-item routerLink="/config" nzMatchRouter>
              <span nz-icon nzType="appstore-add" nzTheme="outline"></span>
              <span>Column Definition</span>
            </li>
            <li nz-menu-item routerLink="/data-sources" nzMatchRouter>
              <span nz-icon nzType="database" nzTheme="outline"></span>
              <span>Data Source Images</span>
            </li>
          </ul>
        </li>
        <li nz-submenu nzTitle="Under Construction" nzIcon="tool" [nzOpen]="isGroupActive(['/assets', '/mapping', '/tracking-lane', '/push-notifications'])">
          <ul>
            <li nz-menu-item routerLink="/assets" nzMatchRouter>
              <span nz-icon nzType="cloud-server" nzTheme="outline"></span>
              <span>Assets Management</span>
            </li>
            <li nz-menu-item routerLink="/mapping" nzMatchRouter>
              <span nz-icon nzType="node-expand" nzTheme="outline"></span>
              <span>Mapping</span>
            </li>
            <li nz-menu-item routerLink="/tracking-lanes" nzMatchRouter>
              <a routerLink="/tracking-lane" style="display: none"></a>
              <span nz-icon nzType="branches" nzTheme="outline"></span>
              <span>Tracking lanes</span>
            </li>
            <li nz-menu-item routerLink="/push-notifications" nzMatchRouter>
              <span nz-icon nzType="notification" nzTheme="outline"></span>
              <span>Test Push Notifications</span>
            </li>
          </ul>
        </li>
        <li nz-menu-item nzMatchRouter>
          <a href="{{api_docs}}" target="_blank">
            <span nz-icon nzType="read" nzTheme="outline"></span>
            <span>API Documentation</span>
          </a>
        </li>
      </ul>
    </nz-sider>
    <nz-layout>
      <nz-header class="app-header">
        <div >
          <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
              <span class="trigger"
                 nz-icon
                 [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
              ></span>
          </span>
          <nz-space class="menu-space" *ngIf="user">
            <nz-avatar
              *nzSpaceItem
              nzIcon="user"
              nzSize="large"
              nzSrc="{{ user.photoUrl }}"
            ></nz-avatar>
            <div *nzSpaceItem class="user-menu">
              Hey {{ user.name }}
            </div>
            <button
                class="btn-header"
                *nzSpaceItem
                nz-button
                nzType="primary"
                nzDanger
                (click)="logout()"
              >
                logout
              </button>
          </nz-space>

        </div>
      </nz-header>
      <nz-content>
        <div class="inner-content">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
</nz-layout>
<ng-template #login>
  <div class="login-layout">
    <div class="login-logo">
      <img src="assets/logo.svg" alt="logo">
       <h1>YOMA Admintool</h1>
    </div>
    <asl-google-signin-button type="standard" size="large" class="google-login"></asl-google-signin-button>
  </div>
</ng-template>
